import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../features/user/userSlice';
import styles from './LogoutPage.module.css';

function LogoutPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(logoutUser());
    navigate('/login');
  }, [dispatch, navigate]);
  return <div className={styles.page}>Logging out...</div>;
}

export default LogoutPage;
